export const FETCH_GROUP = 'FETCH_GROUP';
export const FETCH_GROUP_PENDING = 'FETCH_GROUP_PENDING';
export const FETCH_GROUP_REJECTED = 'FETCH_GROUP_REJECTED';
export const FETCH_GROUP_FULFULLED = 'FETCH_GROUP_FULFILLED';
export const SET_IS_FOLLOWING = 'SET_IS_FOLLOWING';
export const LEAVE_GROUP = 'LEAVE_GROUP'
export const JOIN_GROUP = 'JOIN_GROUP'